import { IAppEntity } from "src/config/entities";
import React from "react";
import { ReferenceTypes } from "src/enums/ReferenceTypes";
import { CashOpeningBalancesDetail } from "src/components/Pages/Documents/CashOpeningBalances/components/CashOpeningBalancesDetail";
import { CashOpeningBalancesService } from "src/services/documents/CashOpeningBalancesService";
import { CashOpeningBalancesDto } from "src/components/Pages/Documents/CashOpeningBalances/dtos/CashOpeningBalancesDto";
import CashOpeningBalancesList from "src/components/Pages/Documents/CashOpeningBalances/components/CashOpeningBalancesList";
import { NFLookupCashOpeningBalances } from "src/components/Shared/NewForms/NFLookupCashOpeningBalances";

export const CashOpeningBalances: IAppEntity = {
  entityType: "document",
  title: "Cash Opening Balances",
  pluralTitle: "Cash Opening Balances",
  apiUrl: "CashOpeningBalances",
  apiEnum: ReferenceTypes.DocumentCashOpeningBalance,
  getDetailView: (id?: string) => {
    return React.createElement(CashOpeningBalancesDetail, {
      id: id
    });
  },
  getDetailViewComponent: (model: any, modelUpdatedEvent: (model: any) => void) => React.createElement(React.Fragment, {}),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(CashOpeningBalancesList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent
    }),

  getLookupComponent(model: any): any {
    return React.createElement(NFLookupCashOpeningBalances, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog
    });
  },
  getDataService: () => new CashOpeningBalancesService("CashOpeningBalances"),
  getEmptyModel: () => {
    const model: CashOpeningBalancesDto = {
      documentDate: new Date(),
      createdDate: new Date(),
      lines: []
    };
    return model;
  }
};